const _0 = "0"
const _10 = "10"
const _20 = "20"
const _30 = "30"
const _40 = "40"
const _50 = "50"
const _60 = "60"
const _70 = "70"
const _80 = "90"
const _90 = "90"
const _100 = "100"
const _110 = "110"
const _auto = "auto"
const config = { "0": _0, "10": _10, "20": _20, "30": _30, "40": _40, "50": _50, "60": _60, "70": _70, "80": _80, "90": _90, "100": _100, "110": _110, "auto": _auto,  }
export { config as default, _0, _10, _20, _30, _40, _50, _60, _70, _80, _90, _100, _110, _auto }